/*
 * // Created on 2023-11-15
 * // Created by Vitaut Tryputsin
 * //
 * // Copyright (c) 2023 OPEN CASCADE SAS
 * //
 * // This file is part of commercial software by OPEN CASCADE SAS,
 * // furnished in accordance with the terms and conditions of the contract
 * // and with the inclusion of this copyright notice.
 * // This file or any part thereof may not be provided or otherwise
 * // made available to any third party.
 * //
 * // No ownership title to the software is transferred hereby.
 * //
 * // OPEN CASCADE SAS makes no representation or warranties with respect to the
 * // performance of this software, and specifically disclaims any responsibility
 * // for any damages, special or consequential, connected with its use.
 *
 */
//! Operation side
export var OperationSide;
(function (OperationSide) {
    OperationSide[OperationSide["Left"] = 0] = "Left";
    OperationSide[OperationSide["Right"] = 1] = "Right";
})(OperationSide || (OperationSide = {}));
//! Operation side
export var SelectionOption;
(function (SelectionOption) {
    SelectionOption[SelectionOption["APP"] = 0] = "APP";
    SelectionOption[SelectionOption["FP"] = 1] = "FP";
})(SelectionOption || (SelectionOption = {}));
//! Computed tomography mode
export var CTMode;
(function (CTMode) {
    CTMode[CTMode["CTFree"] = 0] = "CTFree";
    CTMode[CTMode["CTBased"] = 1] = "CTBased";
})(CTMode || (CTMode = {}));
